import type { TourStep } from '../types';
import { finishStep } from './common';

export const layoutJobSteps: TourStep[] = [
  {
    target: 'body',
    placement: 'center',
    title: 'Паспорт серии',
    content: 'Страница задания показывает, где серия сейчас: студия, каталог, производство, товары и 1С, карточки, продажи. Здесь же чинят ошибки и отправляют листы на приёмку.',
  },
  {
    target: '[data-tour="job-header"]',
    title: 'Шапка',
    content: 'Название, тематика, способ, статус и расход «учтено из лимита».',
  },
  {
    target: '[data-tour="job-main-action"]',
    title: 'Одна главная кнопка',
    content: 'Система сама выбирает самое важное действие: «Разобраться» при ошибках производства, «Открыть студию», «Отправить на приёмку», «Продолжить задание» или «Пауза».',
  },
  {
    target: '[data-tour="job-more"]',
    title: 'Остальные действия',
    content: 'В «…» — всё, что не стало главной кнопкой, и «Остановить задание». Остановка необратима: новые макеты больше не создаются.',
  },
  {
    target: 'nav[aria-label="Путь серии"]',
    title: 'Путь серии',
    content: 'Шесть шагов от студии до продаж. Галочка — готово, часы — идёт, красный треугольник — ошибки. Клик по шагу фильтрует листы ниже.',
  },
  {
    target: '[data-step="production"]',
    title: 'Производство',
    content: 'Файлы печати и визуалы принятых макетов. Красный — есть ошибки: нажмите, чтобы увидеть сломанные листы.',
  },
  {
    target: '[data-testid="job-messages"]',
    title: 'Сообщения',
    content: 'Главная проблема и кнопка её решения: «Задать категории ЯМ», «Повторить производство», «Показать замечания». Остальное — под «ещё N».',
  },
  {
    target: '[role="tablist"][aria-label="Разделы задания"]',
    title: 'Вкладки',
    content: '«Макеты» — листы серии, «Задание» — анкета и настройки, «История и расходы» — события, расходы и версии листов.',
  },
  {
    target: '[aria-label="Фильтр результатов"]',
    title: 'Фильтры листов',
    content: '«С замечаниями», «Готовые», «Без листа», а после приёмки — «Ошибки производства», «Черновики готовы», «Без товаров».',
  },
  {
    target: '[data-tour="select-ready"]',
    title: 'Выбрать готовые',
    content: 'Отмечает все листы, которые можно отправить. Внизу появится панель: «Скачать», «Повторить производство», «Отправить на приёмку».',
  },
  {
    target: 'button[aria-label^="Открыть лист "]',
    title: 'Лист',
    content: 'Клик открывает панель листа: ПИМ, товары и карточки, замечания проверки, «Исправить макет», редактор и PDF.',
  },
  finishStep,
];
